// pages/placement.js
import Swiper from "swiper";
import { Autoplay, A11y } from "swiper/modules";

import "swiper/css";

export function initPlacementPage() {
  const sliders = document.querySelectorAll(
    ".js-placement-career-club-swiper",
  );

  if (sliders.length === 0) return;

  sliders.forEach((slider) => {
    // 初期化済みの場合は重複して生成しない
    if (slider.swiper) return;

    const wrapper = slider.querySelector(".swiper-wrapper");

    if (!wrapper) return;

    const originalSlides = Array.from(
      wrapper.querySelectorAll(":scope > .swiper-slide"),
    );

    if (originalSlides.length < 2) return;

    /*
     * slidesPerView: "auto"かつcenteredSlides: trueの場合、
     * 広い画面では7枚だけではループに必要な枚数が不足するため、
     * 1セット複製して14枚にする
     */
    originalSlides.forEach((slide) => {
      const clone = slide.cloneNode(true);

      clone.setAttribute("aria-hidden", "true");
      clone.dataset.clone = "true";

      // 複製画像は遅延読み込みに変更
      clone.querySelectorAll("img").forEach((image) => {
        image.loading = "lazy";
      });

      wrapper.appendChild(clone);
    });

    new Swiper(slider, {
      modules: [Autoplay, A11y],

      loop: true,
      speed: 800,
      centeredSlides: true,
      slidesPerView: "auto",
      spaceBetween: 20,
      grabCursor: true,

      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },

      breakpoints: {
        768: {
          spaceBetween: 40,
        },
      },

      a11y: {
        enabled: true,
        containerMessage: "TREX Career Clubの活動写真",
        slideLabelMessage: "活動写真 {{index}} / {{slidesLength}}",
      },
    });
  });
}